// GAVION granola-calls (spec 2026-10-14-granola-call-notes §3): the Granola notes of one call (v_timeline call meta
// meeting_note_ids), rendered under the call entry. The note is not repeated as its own timeline item.
import { MeetingNoteTimelineBody } from "./MeetingNoteTimelineBody";

/** meta.meeting_note_ids as numbers (anything else → none). */
export const callNoteIds = (v: unknown): number[] =>
  Array.isArray(v) ? v.map(Number).filter((n) => Number.isFinite(n)) : [];

export const CallMeetingNotes = ({
  noteIds,
}: {
  noteIds: readonly number[];
}) =>
  noteIds.length === 0 ? null : (
    <div className="flex flex-col gap-3 border-l-2 pl-3">
      {noteIds.map((id) => (
        <MeetingNoteTimelineBody key={id} noteId={id} variant="call" />
      ))}
    </div>
  );
